import React from "react";

const renderFieldName = name => {
  switch (name) {
    case "password":
      return "Паролата";
    case "newPassword":
      return "Новата парола";
    case "newPasswordConfirm":
      return "Потвърди нова парола";
    default:
      return name;
  }
};

export const FormErrors = ({ formErrors }) => (
  <div className="formErrors">
    {Object.keys(formErrors).map((fieldName, i) => {
      if (formErrors[fieldName].length > 0) {
        return (
          <p key={i}>
            {renderFieldName(fieldName)} {formErrors[fieldName]}
          </p>
        );
      } else {
        return "";
      }
    })}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/FormPasswordChange/FormErrors.js